import { render } from "./buy-order.vue?vue&type=template&id=03ce10fa&scoped=true"
import script from "./buy-order.vue?vue&type=script&lang=js"
export * from "./buy-order.vue?vue&type=script&lang=js"

import "./buy-order.vue?vue&type=style&index=0&id=03ce10fa&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ce10fa"]])

export default __exports__